import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import store from '../store'

// role code
// co
// localStorage.getItem('role')

Vue.use(VueRouter)
const routes = [
  {
    path: '/home',
    name: 'home',
    component: HomeView,
    meta:{
      requiresAuth:true,
      role:['Teacher']
    }
  },
  {
    path:'/register-teacher',
    name: 'registerUser',
    component: () => import('../views/registerUser.vue'),
    meta:{
      requiresGuest: true,
    }
  },
  {
    path:'/register-student',
    name: 'StudentRegister',
    component: () => import('../views/students-views/StudentRegister.vue'),
    meta:{
      requiresGuest: true,
    }
  },
  {
    path:'/login',
    name: 'LoginUser',
    component: () => import('../views/LoginUser.vue'),
    meta:{
      requiresGuest: true,
    }
  },
  {
    path:'/profile',
    name:'EditProfile',
    component:()=>import('../views/EditProfile.vue'),
    meta:{
      requiresAuth:true,
    }
  },
  {
    path:'/add-notice',
    name:'AddNotice',
    component:()=>import('../views/teacher-views/AddNotice.vue'),
    meta:{
      requiresAuth:true,
      role:['Teacher']
    }
    
  },
  {
    path:'/add-student',
    name:'AddStudent',
    component:()=>import('../views/teacher-views/AddStudent.vue'),
    meta:{
      requiresAuth:true,
      role:['Teacher']
    }

  },
  {
    path:'/add-assignment',
    name: 'AddAssignment',
    component:()=>import('../views/teacher-views/AddAssignment.vue'),
    meta:{
      requiresAuth:true,
      role:['Teacher']
    }
  },
  {
    path:'/assignment-status',
    name:'AssignmentStatus',
    component:()=>import('../views/teacher-views/AssignmentStatus.vue'),
    meta:{
      requiresAuth:true,
      role:['Teacher']
    }
  },
  {
    path:'/student-dashboard',
    name: 'StudentDashboard',
    component:()=>import('../views/students-views/StudentDashboard.vue'),
      meta:{
        requiresAuth:true,
        role:['student']
      }
    },
    {
      path:'/view-assignment',
      name: 'ViewAssignment',
      component:()=>import('../views/students-views/ViewAssignment.vue'),
        meta:{
          requiresAuth:true,
          role:['student']
        }
      },
      {
        path:'/submitted-assignment',
        name:'SubmittedAssignment',
        component:()=>import('../views/students-views/SubmittedAssignment.vue'),
        meta:{
          requiresAuth:true,
          role:['student']
        }
      },
      {
        path:'/view-notice',
        name: 'ViewNotice',
        component:()=>import('../views/students-views/ViewNotice.vue'),
          meta:{
            requiresAuth:true,
            role:['student']
          }
      },
      {
        path:'*',
        name: 'ErrorPage',
        component:()=>import('../views/ErrorPage.vue'),
          meta:{
            requiresAuth:true
          }
        },
]




const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,

})


// Protecting access for non-loggedin user and logged in user

router.beforeEach((to,from,next)=>{
  if(to.matched.some(record=>record.meta.requiresAuth)){
    if(!store.getters.isLoggedIn){
      next('/login')

    }else{
      next()
    }
  }
  else if(to.matched.some(record=>record.meta.requiresGuest)){
    if(store.getters.isLoggedIn){
      next('/')
        // Add code to check role here
    }else{
      next()
    }
  }
})


// check user from getters 
// Testing
// router.beforeEach((to,from,next)=>{
//   if(to.matched.some(record=>record.meta.requiresAuth)){
//     if(!store.getters.isLoggedIn){
//       next('/login')

//     }else{
//       next()
//     }
//   }
//   else if(to.matched.some(record=>record.meta.requiresGuest)){
//     if(store.getters.isLoggedIn){
      
//     if(store.getters.role === 'student'){
//     console.log(store.getters.role)
//     next('/student-dashboard')
//   }
//       // next('/')
//         // Add code to check role here
//        else if(store.getters.role === 'teacher')
//        next('/home') 
//     }else{
//       // alert('routing to homepage')
//       next()
//     }
//   }
// })



export default router
